import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const drawerWidth = 250;
const closedDrawerWidth = 70;

export const navbarStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
        },
        drawer: {
            zIndex: theme.zIndex.drawer + 2,
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: "hidden",
            width: closedDrawerWidth,
            backgroundColor: `${theme.colors.primary.blue75}`,
            flexShrink: 0,
            whiteSpace: "nowrap",
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            overflowY: "initial",
            backgroundColor: `${theme.colors.primary.blue75}`,
        },

        drawerClose: {
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowY: "initial",
            width: closedDrawerWidth,
            backgroundColor: theme.colors.primary.blue75,
        },

        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
        icons: {
            margin: "10px 5px 5px 5px ",
            width: "24px",
            height: "24px",
            minWidth: "30px",
        },
        image: {
            width: " 48px",
            height: "48px",
            margin: "10px 10px 4px 10px",
            float: "left",
        },
        selected: {
            borderLeft: `4px solid  ${theme.colors.primary.blue500}`,
            color: theme.colors.primary.blue500,
            backgroundColor: `${theme.colors.primary.blue75} !important`,
        },
        selectedText: {
            color: theme.colors.primary.blue500,
        },
        downInfo: { position: "absolute", bottom: "0px" },
        drawerOverride: {
            borderRight: "none",
            overflowX: "hidden",
        },
        text: { fontWeight: 600, fontSize: "14px", marginTop: "13px" },
        Unselected: {
            "&:hover": {
                backgroundColor: `${theme.colors.primary.blue75} !important`,
            },
        },

        logo: {
            fontSize: theme.typography.body2.fontSize,
            marginTop: "20px",
            fontWeight: 600,
            lineHeight: "15px",
        },

        openNav: {
            position: "absolute",
            bottom: 0,
            left: 170,
        },

        closeNav: {
            position: "absolute",
            bottom: 0,
        },

        navLeftArrow: {
            margin: "5x 5px 5px 5px ",
            width: "40px",
            height: "40px",
            backgroundColor: "#FFF",
            borderRadius: "4px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },

        navRightArrow: {
            margin: "5x 5px 5px 5px ",
            width: "40px",
            height: "40px",
            backgroundColor: "#FFF",
            borderRadius: "4px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },

        expandButton: {
            padding: "0px",
            position: "relative",
            left: 20,
            alignSelf: "end",
            marginBottom: 23,
            boxShadow: "0px 4px 10px rgba(110, 102, 102, 0.2)",
            border: `1px solid ${theme.colors.primary.blue200}`,
            borderRadius: theme.shape.borderRadius,
        },

        expandButtonOpened: {
            borderColor: theme.colors.primary.blue300,
        },

        grow: {
            flexGrow: 1,
        },
    })
);
